import { render } from "./SkipUnitCreation.vue?vue&type=template&id=6ca6c4c6&scoped=true"
import script from "./SkipUnitCreation.vue?vue&type=script&lang=js"
export * from "./SkipUnitCreation.vue?vue&type=script&lang=js"

import "./SkipUnitCreation.vue?vue&type=style&index=0&id=6ca6c4c6&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca6c4c6"]])

export default __exports__